export const SessionTimeConstraint = {
    AM: 'AM',
    PM: 'PM',
    ALL: 'All',
};